import React from 'react';
import { HeroSection } from './components/HeroSection';
import { HeroTestimonials } from './components/HeroTestimonials';
import { ProblemSection } from './components/ProblemSection';
import { TomosSection } from './components/TomosSection';
import { BonosSection } from './components/BonosSection';
import { OfferSection } from './components/OfferSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FaqSection } from './components/FaqSection';
import { CostSection } from './components/CostSection';
import { FinalCtaSection } from './components/FinalCtaSection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-full w-full bg-black text-[var(--cream)]" data-id="element-0" data-mp="2wip6b2g4hi4x">
      <main data-id="element-1" data-mp="28te0v7ntuzkg">
        <HeroSection data-id="element-2" data-mp="28t4ju9krg2qw" />
        <HeroTestimonials data-id="element-3" data-mp="28sbbj465l56n" />
        <ProblemSection data-id="element-4" data-mp="23vcmh01cjofb" />
        <TomosSection data-id="element-5" data-mp="23w4ey1znd61d" />
        <BonosSection data-id="element-6" data-mp="23utcq6luo6cd" />
        <OfferSection data-id="element-7" data-mp="23t8gmcjw0fce" />
        <TestimonialsSection data-id="element-8" data-mp="3ik7gihlkcdr6" />
        <GuaranteeSection data-id="element-9" data-mp="3iiweonbohg2p" />
        <FaqSection data-id="element-10" data-mp="3ijpcgysnsv8p" />
        <CostSection data-id="element-11" data-mp="3ii4r9zs8ioni" />
        <FinalCtaSection data-id="element-12" data-mp="3mlatmwc87vop" />
      </main>
      <Footer data-id="element-13" data-mp="3mk83wrqn3zad" />
    </div>;
}